<template>
    <li class="menu-item-horizontal-li">
        <div class="menu-item-horizontal-wrap"
             @click="openFullItem">
            <div class="menu-item-horizontal-image-wrap">
                <img v-if="!!item.image"
                     :src="item.image"
                     :alt="item.name">
                <img v-else
                     src="@/assets/img/menus/pic1.jpg"
                     :alt="item.name">

                <div class="menu-item-horizontal-add"
                     v-if="canOrder">
                    <IconPlus />
                </div>
            </div>
            <div class="menu-item-horizontal-info">
                <div class="menu-item-horizontal-name">{{ item.name }}</div>
                <div class="menu-item-horizontal-footer">
                    <span class="menu-item-horizontal-price">{{ item.price }} zł</span>
                </div>
            </div>
        </div>
        <DishDetails v-if="showFullItem"
                     ref="detailsRef"
                     v-model="showFullItem"
                     :dish-id="item.id"
                     :dish="item" />
    </li>
</template>

<script>
import IconPlus from '@/components/icons/IconPlus.vue';
import DishDetails from '@/modules/dishDetails/DishDetails.vue';

export default {
    name: "MenuHorizontalItem",
    components: {
        IconPlus,
        DishDetails,
    },
    props: {
        item: { type: Object, required: true }
    },
    data() {
        return {
            showFullItem: false,
        };
    },
    computed: {
        canOrder() {
            const locale = this.$store.getters['getCompanyData'].locale;

            return (locale.activePaymentCredentials || this.$store.getters['getIsModeHOT'] || this.$store.getters['getIsModeSOT'])
                && locale.pos_terminal_enabled
                && locale.smart_menu_cart_enabled;
        },
    },
    methods: {
        openFullItem() {
            this.showFullItem = true;
            this.$nextTick(() => {
                this.$refs.detailsRef.open();
            });
        },
    }
};
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

.slide-up-enter-active {
    transition: all .4s ease;
}

.slide-up-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-up-enter,
.slide-fade-leave-to {
    transform: translateY(100vh);
    opacity: 0;
}

.menu-item-horizontal-li {
    flex-shrink: 0;
    margin-bottom: 10px;

    height: 205px;
    width: 160px;

    border-radius: 12px;

    box-shadow: 0px 1px 10px 0px #0000001A;
}

.menu-item-horizontal-wrap {
    display: flex;
    flex-direction: column;

    height: 100%;
}

.sold {
    opacity: 50%;
}

.menu-item-horizontal-image-wrap {
    position: relative;

    width: 100%;
    height: 120px;

    img {
        width: 100%;
        height: 100%;

        object-fit: cover;

        border-radius: 12px 12px 0 0;

        // filter: drop-shadow(0px 1000px 0 red);
        // transform: translateY(-1000px);
    }


    .menu-item-horizontal-add {
        display: flex;

        position: absolute;
        bottom: 6px;
        right: 6px;

        border-radius: 6px;

        box-shadow: 0px 1px 10px 0px #0000001A;
        background-color: white;
    }
}


.menu-item-horizontal-info {
    display: flex;
    flex-direction: column;

    flex-grow: 1;

    padding: 8px;

    .menu-item-horizontal-name {
        margin-bottom: auto;

        font-weight: 700;
        font-size: 16px;
        line-height: 20px;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        color: black;
    }


    .menu-item-horizontal-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .menu-item-horizontal-price {
            font-weight: 700;
            font-size: 16px;
            line-height: 100%;
            text-align: center;

            color: $color_blue_cornflower;
        }
    }
}
</style>
